export const ONE_SECOND_IN_MS = 1000;
export const ONE_MINUTE_IN_SEC = 60;
export const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * ONE_MINUTE_IN_SEC;
export const ONE_HOUR_IN_MS = ONE_MINUTE_IN_MS * ONE_MINUTE_IN_SEC;
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;
export const ONE_HOUR_IN_SEC = ONE_MINUTE_IN_SEC * 60;
export const ONE_DAY_IN_SEC = ONE_HOUR_IN_SEC * 24;
